import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

/**
 * Return new Carousel dot
 * @param {Number} i Reference to the index of the dot
 * @param {Number} activeSlide Reference to the current active slide index
 * @param {Function} onClick Function to call when the dot is clicked
 */
const CustomPaging = ({ i, activeSlide, onClick }) => {
    const isActive = i == activeSlide
    return (
        <div
            onClick={onClick}
            className={clsx(
                'rounded-full mt-12 transition',
                isActive
                    ? 'w-2.5 h-2.5 bg-gray-400'
                    : 'w-2 h-2 bg-gray-200 hover:bg-gray-400',
            )}
        />
    )
}

CustomPaging.propTypes = {
    i: PropTypes.number,
    activeSlide: PropTypes.number,
    onClick: PropTypes.func,
}

export default CustomPaging
